import { useQuery } from "react-query";
import AvailableTranslationReferenceCacheName from "../../utils/AvailableTranslationReferenceCacheName";
import { fetchAvailableTranslationsForReference } from "../../api/fetchTranslationReference";

/* hook that calls the api to fetch translations that are eligible to be referenced by other translations */
export const useEligibleTranslationForReference = () => {
  return useQuery({
    queryKey: [AvailableTranslationReferenceCacheName.getAvailableTranslationReference()],
    queryFn: fetchAvailableTranslationsForReference,
    refetchOnMount: true,
  });
};
